import { render, staticRenderFns } from "./communityactivityreportDetail.vue?vue&type=template&id=57b88e48&"
import script from "./communityactivityreportDetail.vue?vue&type=script&lang=js&"
export * from "./communityactivityreportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports